var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessStudies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business_Studies",
    "data-name": "Business Studies",
    transform: "translate(21301 -2138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21301 2138)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_51",
    "data-name": "Union 51",
    d: "M20.594,57.686a1.5,1.5,0,0,1-.148-2.116L28.766,46H5a5.005,5.005,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H57a5.006,5.006,0,0,1,5,5V41a5.005,5.005,0,0,1-5,5H34.236l8.319,9.57a1.5,1.5,0,0,1-2.264,1.969L33,49.153V56.5a1.5,1.5,0,0,1-3,0V49.153l-7.289,8.385a1.5,1.5,0,0,1-2.117.148ZM2,5V41a3,3,0,0,0,3,3H57a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5ZM40,32.5a7.506,7.506,0,0,1,9.51-7.227L47.3,32.494l7.5-1.706A7.5,7.5,0,1,1,40,32.5Zm.286,4.5H36V17a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1V27.022A8.5,8.5,0,0,0,40.287,37v0ZM27,37V20a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1V37Zm-9,0V24a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1V37ZM9,37V19a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1V37ZM50.705,24.273A7.514,7.514,0,0,1,56,29.786l-7.5,1.707Zm-5.706.1V16a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v8.372a8.572,8.572,0,0,0-5,0ZM18,18.5a2.517,2.517,0,0,1,.035-.422l-4.689-2.893a2.491,2.491,0,1,1,.459-.715c1.41.864,3.177,1.936,4.54,2.761a2.5,2.5,0,0,1,4.393.153l4.353-2.214a2.5,2.5,0,0,1,4.56-1.946l4.362-1.469A2.53,2.53,0,0,1,36,11.5a2.5,2.5,0,0,1,4.869-.8L45,10.348a2.5,2.5,0,1,1,.113.911c-1.295.12-2.85.261-4.12.377a2.5,2.5,0,0,1-4.731.988l-4.3,1.434a2.5,2.5,0,0,1-4.5,1.885l-4.467,2.341Q23,18.39,23,18.5a2.5,2.5,0,0,1-5,0Z",
    transform: "translate(-21287 2154)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessStudies);
export default __webpack_public_path__ + "static/media/Business Studies.b7930101.svg";
export { ForwardRef as ReactComponent };